import QuestionLabel from './QuestionLabel';
import Table from '~/components/Table';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import {
    calculateLineItemTotal,
} from '~/lib/InvoiceLineItemHelpers';
import InlineEditableItemContainer from '~/components/forms/questions/components/InlineEditableItemContainer';

const InvoiceLineItemsQuestion = ({
    label,
    value,
    setValue,
    settings,
}) => {
    const lineItems = (settings?.lineItems || []).filter(item => !!item.name || !!item.unitPrice);

    if (lineItems.length === 0) {
        return (
            <div>
                <div className="font-medium mb-2">Line Items</div>
                <InlineEditableItemContainer className="text-center text-primary-700 font-medium">
                    + Add Line Items
                </InlineEditableItemContainer>
            </div>
        );
    }

    // Read-only view
    const rows = lineItems.map(item => [
        <div>
            <div>{item.name || 'Untitled Item'}</div>
            {item.description && <div className="text-sm text-gray-500">{item.description}</div>}
        </div>,
        item.quantity || 0,
        formatCurrency(item.unitPrice || 0),
        formatCurrency(calculateLineItemTotal(item))
    ]);

    return (
        <div>
            <div className="font-medium mb-2">Line Items</div>
            <InlineEditableItemContainer>
                <Table
                    headers={['Item', 'Quantity', 'Price', 'Total']}
                    rows={rows}
                    onClick={() => {}}
                    bodyClassName="bg-gray-200 bg-opacity-50"
                    className="border-separate"
                    noBorder={true}
                />
            </InlineEditableItemContainer>
        </div>
    );
};

export default InvoiceLineItemsQuestion;

